import { useQuery } from "@tanstack/react-query";
import { api } from "@/api/client";
import { PromptStabilityResponseSchema } from "@/api/schemas";
import type { TimeRange } from "@/components/TimeRangeSelector";

export function usePromptStability(tenantId: string, range: TimeRange) {
  return useQuery({
    queryKey: ["prompt-stability", tenantId, range.from, range.to],
    queryFn: async () => {
      const json = await api
        .get("prompt-stability", {
          searchParams: {
            from: range.from,
            to: range.to,
          },
        })
        .json();
      return PromptStabilityResponseSchema.parse(json);
    },
    enabled: !!tenantId,
  });
}
